module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery6-cbd74beaa4f0a6283ad1e12a6584e791.jpg";